export default function AboutHero() {
  return (
    <section className="relative min-h-[70vh] flex flex-col justify-center pt-24 pb-16 overflow-hidden bg-graphite-900">
      <div className="absolute inset-0 bg-gradient-to-b from-graphite-850 via-graphite-900 to-graphite-900"></div>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-emerald-accent/5 via-transparent to-transparent"></div>
      <div className="absolute inset-0 grid-pattern opacity-30"></div>
      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-graphite-700 bg-graphite-800/60 mb-6">
            <span className="text-xs font-medium text-silver-300 tracking-wide">About StackMap Systems</span>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight tracking-tight mb-8">Who We Are</h1>
          <p className="text-base sm:text-lg md:text-xl text-silver-300 leading-relaxed mb-6">
            StackMap Systems is an enterprise software company focused on helping organizations operate with greater clarity, control, and efficiency. We design and deploy both off-the-shelf and bespoke SaaS solutions that enable businesses to manage people, operations, performance, billing, and internal workflows from a single, structured platform.
          </p>
          <p className="text-base md:text-lg text-silver-300 leading-relaxed mb-6">
            Our systems are built from real operational environments, not theory. We understand the challenges businesses face as they grow, and we build solutions that reflect how work actually gets done.
          </p>
          <p className="text-base md:text-lg text-emerald-accent font-medium leading-relaxed">
            StackMap is not just software. It is the operational infrastructure required to scale.
          </p>
        </div>
      </div>
    </section>
  );
}
